import { useSendContactFormMutation as useSendContactFormMutationTokko } from '@apis/originalTokkoApi/contact'
import { useCreateFormMutation as useSendContactFormMutationMediacore } from '@apis/mediacore/contact'
import { makeJsonContact } from '@helpers/helper.contact'
import React, { useEffect, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import toast, { Toaster } from 'react-hot-toast'
import { Development, Property, RealEstateDataPageComponentData } from 'types'
import $ from 'jquery'

interface PropsType {
  property?: Property
  development?: Development
  from: string
  smallPadding?: boolean
  focusSecondary?: boolean
}

type CombinedProps = RealEstateDataPageComponentData & PropsType

const Form_1 = (props: CombinedProps) => {
  //   const [text, setText] = useState('')
  const [disabled, setDisabled] = useState(true)
  //   const { data } = props
  // const { from = '' } = props
  const {
    property,
    development,
    underlineMode,
    button,
    global_data,
    smallPadding = false,
    is_short = false,
    focusSecondary = false,
    customBorderRadius,
  } = props

  const API_KEY = global_data.pageConfig.keys.tokko
  const captcha = global_data.pageConfig.keys.captcha
  const divisionPath = global_data.divisionPath
  const realEstateName = global_data.name
  const [sendContactFormTokko] = useSendContactFormMutationTokko()
  const [sendContactFormMediacore] = useSendContactFormMutationMediacore()
  const [datos, setDatos] = useState({
    name: '',
    cellphone: '',
    email: '',
    text: '',
  })

  const handleInputChange = (event: any) => {
    setDatos({
      ...datos,
      [event.target.name]: event.target.value,
    })
  }

  const [token, setValueToken] = useState('')

  function onChange(value: any) {
    setValueToken(value)
  }

  const sendForm = (event: any) => {
    event.preventDefault()
    var tags = [...getUtm(), 'Sitio Web', realEstateName]
    if (process.env.GATSBY_IS_SITE_COMPILER === 'true') {
      tags.push(divisionPath!.replaceAll('/', ''))
    }
    if (!development?.id && !property?.id) {
      tags.push('Contacto')
    }

    if (property?.id) {
      tags.push('Propiedad')
    }

    if (development?.id) {
      tags.push(development.name)
    }

    const { name, cellphone, email, text } = datos

    const body = makeJsonContact({
      name,
      cellphone,
      email,
      text,
      tags,
      property,
      development,
    })

    const type = development ? 'development' : property ? 'property' : 'contact'

    if (API_KEY) {
      // sendContactFormTokko({ API_KEY: API_KEY, body: body })
      sendContactFormMediacore({
        data: {
          ...datos,
          tags: tags,
          property: property,
          development: development,
          url: location.href,
          token: token,
        },
        type: type,
        site: global_data.id,
      })
    } else {
      sendContactFormMediacore({
        data: {
          ...datos,
          tags: tags,
          property: property,
          development: development,
          url: location.href,
          token: token,
        },
        type: type,
        site: global_data.id,
      })
    }
    ;(document?.getElementById('formContact') as HTMLFormElement).reset()
    return toast.success('¡Mensaje enviado correctamente!')
  }

  useEffect(() => {
    if (!captcha) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
    $('.btn-form-hover')
      .hover(function () {
        // $(this).css('background', button?.valueColor!)
        $(this).css('background', button?.valueColor! || '#fff')
        $(this).css('color', button?.backgroundColor! || 'var(--primaryColor)')
        $(this).css('border', `1px solid ${button?.backgroundColor! || 'var(--primaryColor)'}`)
        $('#submit-info').css('color', button?.backgroundColor! || 'var(--primaryColor)')
        // $(this).css('border', '1px solid ' + button?.backgroundColor! || 'var(--primaryColor)')
      })
      .mouseout(function () {
        // $(this).css('background', button?.backgroundColor!)
        $(this).css('background', button?.backgroundColor! || 'var(--primaryColor)')
        $(this).css('color', button?.valueColor! || '#fff')
        $(this).css('border', '1px solid ' + button?.borderColor! || '#fff')
        $('#submit-info').css('color', button?.valueColor! || '#fff')
      })
  }, [])

  const getUtm = () => {
    if (typeof window !== 'undefined') {
      var queryString = window.location.search
      var urlParams = new URLSearchParams(queryString)
      const tags = []
      for (const [key, value] of urlParams) {
        if (key.includes('source')) {
          tags.push('Origen: ' + value)
        }
        if (key.includes('medium')) {
          tags.push('Pieza: ' + value)
        }
        if (key.includes('campaign')) {
          tags.push('Campaña: ' + value)
        }
      }
      return tags
    }
    return []
  }

  return (
    <form
      onSubmit={sendForm}
      id="formContact"
      className={
        'row content-form ajax-form ' +
        (underlineMode ? 'undeline_mode' : '') +
        (smallPadding ? ' small_padding ' : '') +
        (focusSecondary ? ' focus-secondary ' : '')
      }
    >
      <div className={`col-lg-4 mb-lg-4`}>
        <input
          type="text"
          name="name"
          onChange={handleInputChange}
          placeholder="Nombre"
          style={customBorderRadius ? { borderRadius: `${customBorderRadius}px` } : {}}
        />
      </div>
      <div className={`col-lg-4 mb-lg-4`}>
        <input
          type="text"
          name="name"
          onChange={handleInputChange}
          placeholder="Apellido"
          style={customBorderRadius ? { borderRadius: `${customBorderRadius}px` } : {}}
        />
      </div>
      <div className="col-lg-4 mb-lg-4">
        <textarea
          name="text"
          rows={1}
          onChange={handleInputChange}
          placeholder="Mensaje"
          style={customBorderRadius ? { borderRadius: `${customBorderRadius}px` } : {}}
        />
      </div>
      <div className="col-lg-4 mb-lg-4">
        <input
          type="text"
          name="email"
          onChange={handleInputChange}
          placeholder="Mail*"
          required
          style={customBorderRadius ? { borderRadius: `${customBorderRadius}px` } : {}}
        />
      </div>
      {!is_short && (
        <div className="col-lg-4 mb-lg-4">
          <input
            type="text"
            name="cellphone"
            onChange={handleInputChange}
            placeholder="Teléfono"
            style={customBorderRadius ? { borderRadius: `${customBorderRadius}px` } : {}}
          />
        </div>
      )}
      <div className="col-lg-4 d-lg-flex justify-content-between mb-5">
        <p className="d-block d-lg-none">*Campo obligatorio.</p>
        <div className="">
          {captcha ? (
            <ReCAPTCHA
              sitekey={captcha}
              onChange={(value) => {
                setDisabled(false)
                onChange(value)
              }}
            />
          ) : (
            ''
          )}
          <div
            className={'btn btn-form-hover submit mt-4 w-100 ' + (button?.border ? ' border ' : '')}
            style={{
              background: button?.backgroundColor || 'var(--primaryColor)',
              color: button?.valueColor || '#fff',
              borderRadius: `${customBorderRadius}px`,
              border: `1px solid ${button?.borderColor! || '#fff'}`,
            }}
          >
            <input
              type="submit"
              disabled={disabled}
              value={button?.value || 'Enviar'}
              style={{
                background: 'transparent',
                border: 'none',
                color: button?.valueColor || '#fff',
              }}
              id="submit-info"
            />
            {button?.image && (
              <img
                src={button?.image}
                alt=""
              />
            )}
          </div>
        </div>
        {/* <p className="d-none d-lg-block">*Campo obligatorio.</p> */}
      </div>
    </form>
  )
}
export default Form_1
